import { Location, PlatformLocation } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceService, EventTrackerService, LogService, TypeShowLogInConsole } from '@app/core';
import { AdtraceService } from '@app/core/ad-trace/adtrace.service';
import { HttpService } from '@app/core/http/http.service';
import { AppParametersService } from '@app/core/token/app-parameters.service';
import { TokenService } from '@app/core/token/token.service';
import { IndicatorService } from '@app/shared';
import { iNotification, NotificationService } from '@app/shared/notification/notification.service';
import { environment } from '@env/environment';
import { Subscription, SubscriptionLike } from 'rxjs';

import { SubscriptionService } from '../subscription.service';
import { SubscriptionItemResponse, SubscriptionStatusResponse } from '../subscriptionStatusResponse';

@Component({
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})

export class SubscriptionComponent implements OnInit, OnDestroy {
  private readonly CB_SUBSCRIPTION = 'CB_subscription_NotValidate';
  public _environment = environment;
  public _startSlideIndex = null;
  public productIdSeleted: any;
  private Location$: SubscriptionLike = new Subscription();
  public modalState: boolean = false;
  public subscriptionPlans: Array<SubscriptionItemResponse>;
  public userSubscriptionStatus: SubscriptionStatusResponse = null;

  public isMarkets: boolean = false;
  public marketsInProccess: boolean = false;
  public marketsStatusText: string;
  public marketsInstaled: boolean = true;
  private TypeMarkets: string;
  private TypeMarketsfa: string;
  public isLogin: boolean = false;

  constructor(
    private readonly parametersService: AppParametersService,
    public readonly tokenService: TokenService,
    private readonly adtrace: AdtraceService,
    private readonly notification: NotificationService,
    public readonly device: DeviceService,
    private readonly indicator: IndicatorService,
    private readonly subscriptionService: SubscriptionService,
    private readonly http: HttpService,
    private readonly log: LogService,
    private readonly _platformlocation: PlatformLocation,
    private readonly location: Location,
    private readonly analytics: EventTrackerService,
    private readonly router: Router) {
    this.indicator.show();
  }


  public ngOnInit() {
    if (this.device.isMarkets()) {
      this.TypeMarkets = this.device.typeMyket();
      this.TypeMarketsfa = this.device.isCaffebazar() ? 'کافه بازار' : 'مایکت';
      this.log.logger(`checkUnConsume${this.TypeMarkets} on subscription page START >>`);
      (window as any).Android.checkUnConsumeCafebazaar();

      if (localStorage.getItem(this.CB_SUBSCRIPTION) !== null) {
        this.marketsStatusText = 'شما خرید تایید نشده دارید . لطفا منتظر بمانید...';

        this.http.checkMarketsToken(JSON.parse(localStorage.getItem(this.CB_SUBSCRIPTION)))
          .subscribe((res: any) => {
            this.log.logger(`validate ${this.TypeMarkets} purchase in subscription history storage`);
            this.log.logger(res);
            this.device.setMarketsNewStatus(10, 'subscription');
            localStorage.removeItem(this.CB_SUBSCRIPTION);
          }, err => {
            this.log.logger(`validate ${this.TypeMarkets} purchase in subscription history storage errrrror`);
            this.log.logger(err);
            if (err.status == 500) {
              localStorage.removeItem(this.CB_SUBSCRIPTION);
              this.device.setMarketsNewStatus(0, 'subscription');
            }
          }, () => {
            localStorage.removeItem(this.CB_SUBSCRIPTION);
          });
      }

      this.device.marketsSubscriptionStatus$.subscribe(data => {
        this.log.logger(`sucscribe ${this.TypeMarkets}SubscriptionStatus$ >>>>>`);
        this.log.logger(data);
        if (data == 1) {
          this.marketsStatusText = `در حال دریافت اطلاعات از ${this.TypeMarketsfa} ...`;
        } else if (data == 6) {
          this.marketsStatusText = 'در حال ثبت طرح اشتراک خریداری شده ...';
        } else if (data == 10) {

          // this.disableBtn = false;
          this.marketsInProccess = false;
          this.marketsStatusText = 'طرح اشتراک شما با موفقیت ثبت شد';
          let item = this.subscriptionPlans.find(c => c.product.productId == this.productIdSeleted);
          this.adtrace.Adtrace(item.product.price);
          this.router.navigateByUrl('/profile');
          this.device.setMarketsNewStatus(0, 'subscription');
        } else if (data == 20) {
          this.marketsInstaled = false;
          this.marketsStatusText = `در این نسخه از اپلیکیشن نوار، خرید تنها از طریق پرداخت درون‌برنامه‌ای ${this.TypeMarketsfa} امکان‌پذیر است.`;
        } else if (data == 21) {
          // cancel
          this.marketsStatusText = '';
        }
      });
    }

    this.tokenService.isLogin$.subscribe(c => {
      this.isLogin = c;
      if (c) {
        this.subscriptionService.getUserSubscriptionStatus().subscribe(c => this.getUserSubscriptionStatus(c));
      }
    });
    this.subscriptionService.getSubscriptionPlans().subscribe(c => {
      this.getSubscriptionList(c);
      this.indicator.hide()
    },
      err => console.log(err),
      () => { });
    this.Location$ = this.location.subscribe(event => {
      this.log.logger('Location changed to >>' + event.url + '<<');
      if (this.modalState) {
        this.modalState = false;
        this.indicator.hide();
      }
    });
  }
  private getUserSubscriptionStatus(data): void {
    this.log.logger('user subscription status =');
    this.log.logger(data, TypeShowLogInConsole.table);
    this.userSubscriptionStatus = data;
  }

  public getSubscriptionList(data): void {
    this.subscriptionPlans = data.items;
    this.log.logger('subscription plans = ');
    this.log.logger(this.subscriptionPlans, TypeShowLogInConsole.table);
    this.subscriptionPlans.forEach((element, index) => {
      let limits = [element.totalQuotaDesc, element.extraBooksDiscountDesc];
      if (element.limits[0])
        limits = [...limits, element.limits[0]];
      if (element.limits[1])
        limits = [...limits, element.limits[1]];
      this.subscriptionPlans[index].limits = limits;
    });
  }
  public onShowNotification(e: iNotification) {
    this.notification.setNotification(e);
  }
  public openSlider(item, index, itemTitle): void {
    this.log.logger('openSlider start');
    this.log.logger('index button clicked is : ' + index);
    this.analytics.logEvent('x_btn_tap', { location_screen: 'profile', x_button_id: 'subscription', x_button_caption: itemTitle });
    this._startSlideIndex = index;
    this._platformlocation.pushState(null, null, this.location.path() + '#modalOpened');
    this.modalState = true;
  }
  public gotoCart(productId): void {
    if(!this.isLogin){
      this.device.goTologinPageNative('subscription');
      return;
    }

    let _productId = this.productIdSeleted = productId.productId;
    this.log.logger(`product id selected : ${_productId}`);
    if (this.device.isMarkets()) {
      this.log.logger(`is${this.TypeMarkets} and call startPurchase${this.TypeMarkets}() >> subscription')`);
      if (!this.marketsInstaled) {
        return;
      }
      this.device.setMarketsNewStatus(1, 'subscription');
      // call in-app purchase native
      (window as any).Android.startPurchaseCafeBazzar(productId.skuId, _productId + '@subscription');
    } else {
      this.device.purchaseBook(_productId);
    }
    if (!this.device.isMarkets())
      this.indicator.showHude(true);
    this.location.back();
  }

  public ngOnDestroy(): void {
    this.Location$.unsubscribe();
  }
}
